(function () {
  var KEY = "__igoHideLowDiscountSavings";
  var BADGE_SELECTOR = ".sale_savings, .sale.savings";
  var SAFE_SCOPE_SELECTOR = [
    ".product-thumbnail",
    "[class*=\"product-thumbnail\"]",
    ".product-thumbnail__price",
    ".product-card",
    ".product-grid",
    ".product-list",
    ".collection",
    ".collection-template",
    ".featured-collection",
    ".featured-products",
    ".related-products",
    ".recommended-products",
    ".product",
    ".product-template",
    ".product__price",
    ".price",
    ".sale",
    ".money",
    ".rebuy-cart",
    ".rebuy-cart__flyout",
    ".rebuy-cart__flyout-content",
    ".rebuy-smartcart",
    ".cart-drawer",
    ".mini-cart",
    "[class*=\"product\"]",
    "[class*=\"price\"]",
    "[class*=\"money\"]",
    "[class*=\"rebuy\"]",
    "[class*=\"cart-drawer\"]",
    "[class*=\"slideout\"]",
    "[data-ajax-cart]",
    "[data-rebuy-id]"
  ].join(",");
  if (window[KEY] && window[KEY].observer) {
    window[KEY].observer.disconnect();
  }
  window[KEY] = window[KEY] || {};
  function isCheckoutPage() {
    return /\/checkouts?(\/|$)/i.test(window.location.pathname);
  }
  function getPercent(badge) {
    var percentElement = badge.querySelector(".savings-percent");
    var percentText = percentElement ? percentElement.textContent : "";
    var match = percentText.replace(",", "").match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }
  function isInSafeScope(element) {
    return !!(element && element.closest && element.closest(SAFE_SCOPE_SELECTOR));
  }
  function getSavingsMoneyElement(percentElement) {
    var node = percentElement.nextSibling;
    while (node) {
      if (node.nodeType === 1 && (node.classList.contains("money") || node.hasAttribute("data-currency-original"))) {
        return node;
      }
      node = node.nextSibling;
    }
    return null;
  }
  function getClosingParenText(moneyElement) {
    if (!moneyElement || !moneyElement.nextSibling || moneyElement.nextSibling.nodeType !== 3) {
      return null;
    }
    return moneyElement.nextSibling;
  }
  function setBadgeVisibility(percentElement, shouldHide) {
    if (!percentElement) {
      return;
    }
    var nextText = percentElement.nextSibling && percentElement.nextSibling.nodeType === 3 ? percentElement.nextSibling : null;
    var moneyElement = getSavingsMoneyElement(percentElement);
    var closingText = getClosingParenText(moneyElement);
    if (!shouldHide && percentElement.getAttribute("data-low-discount-hidden") !== "true") {
      return;
    }
    if (shouldHide) {
      percentElement.setAttribute("data-low-discount-hidden", "true");
      percentElement.style.setProperty("display", "none", "important");
      if (nextText) {
        if (!percentElement.__lowDiscountNextText) {
          percentElement.__lowDiscountNextText = nextText.textContent;
        }
        nextText.textContent = nextText.textContent.replace(/^\s*\(\s*/, "");
      }
      if (closingText) {
        if (!percentElement.__lowDiscountClosingText) {
          percentElement.__lowDiscountClosingText = closingText.textContent;
        }
        closingText.textContent = closingText.textContent.replace(/\s*\)\s*$/, "");
      }
      return;
    }
    percentElement.removeAttribute("data-low-discount-hidden");
    percentElement.style.removeProperty("display");
    if (nextText && percentElement.__lowDiscountNextText) {
      nextText.textContent = percentElement.__lowDiscountNextText;
      percentElement.__lowDiscountNextText = null;
    }
    if (closingText && percentElement.__lowDiscountClosingText) {
      closingText.textContent = percentElement.__lowDiscountClosingText;
      percentElement.__lowDiscountClosingText = null;
    }
  }
  function clearLegacyBadgeVisibility(badge) {
    if (badge.getAttribute("data-low-discount-hidden") !== "true") {
      return;
    }
    badge.removeAttribute("data-low-discount-hidden");
    badge.style.removeProperty("visibility");
  }
  function processBadges(root) {
    if (isCheckoutPage()) {
      return;
    }
    var scope = root && root.querySelectorAll ? root : document;
    var badges = [];
    if (scope.matches && scope.matches(BADGE_SELECTOR)) {
      badges.push(scope);
    }
    badges = badges.concat(Array.prototype.slice.call(scope.querySelectorAll(BADGE_SELECTOR)));
    badges.forEach(function (badge) {
      if (!isInSafeScope(badge)) {
        return;
      }
      clearLegacyBadgeVisibility(badge);
      var percent = getPercent(badge);
      if (percent === null || Number.isNaN(percent)) {
        return;
      }
      setBadgeVisibility(badge.querySelector(".savings-percent"), percent < 5);
    });
  }
  function scheduleProcess() {
    if (window[KEY].frame) {
      window.cancelAnimationFrame(window[KEY].frame);
    }
    window[KEY].frame = window.requestAnimationFrame(function () {
      window[KEY].frame = null;
      processBadges(document);
    });
  }
  function init() {
    if (!document.body || isCheckoutPage()) {
      return;
    }
    processBadges(document);
    window[KEY].observer = new MutationObserver(function (mutations) {
      var shouldProcess = mutations.some(function (mutation) {
        return mutation.type === "characterData" || Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1;
        });
      });
      if (shouldProcess) {
        scheduleProcess();
      }
    });
    window[KEY].observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
